<template>
<!--  <div class="scroll-downs" :style="{ bottom: bottom, top: top, left: left, right:right }">-->
<!--    <div class="mousey">-->
<!--      <div class="scroller"></div>-->
<!--    </div>-->
<!--  </div>-->

  <div class="arrow">
    <span></span>
<!--    <span></span>-->
<!--    <span></span>-->
  </div>
</template>

<script>
export default {
  name: "ScrollIcon",
  props: ["bottom", "top", "left", "right"],
}
</script>

<style scoped lang="scss">
.arrow{
  position: absolute;
  //top: 50%;
  left: 50%;
  bottom: 23vh;
  transform: translate(-50%,-50%);

  @include lg {
    display: none;
  }
}
.arrow span{
  display: block;
  width: 15px;
  height: 15px;
  border-bottom: 3px solid $gray;
  border-right: 3px solid $gray;
  transform: rotate(45deg);
  margin: -10px;
  animation: animate2 2s infinite;
}
//.arrow span:nth-child(2){
//  animation-delay: -0.2s;
//}
//.arrow span:nth-child(3){
//  animation-delay: -0.4s;
//}

@keyframes animate2 {
  0%{
    transform: rotate(45deg) translate(0,0);
  }
  20%{
    transform: rotate(45deg) translate(-10px,-10px);
  }
  40%{
    transform: rotate(45deg) translate(0,0);
  }
}

@keyframes sdb04 {
  0% {
    transform: rotate(-45deg) translate(0, 0);
  }
  20% {
    transform: rotate(-45deg) translate(-10px, 10px);
  }
  40% {
    transform: rotate(-45deg) translate(0, 0);
  }
}


//.scroll-downs {
//  position: absolute;
//  //top: 0;
//  //right: 0;
//  //bottom: 0;
//  //left: 0;
//  //margin: auto;
//  width: 34px;
//  height: 55px;
//  margin: 1rem;
//}
//.mousey {
//  width: 3px;
//  padding: 10px 15px;
//  height: 35px;
//  border: 2px solid $gray;
//  border-radius: 25px;
//  opacity: 1;
//  box-sizing: content-box;
//  background: $white;
//  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
//}
//.scroller {
//  width: 3px;
//  height: 10px;
//  border-radius: 25%;
//  background-color: $gray;
//  animation-name: scroll;
//  animation-duration: 2.2s;
//  animation-timing-function: cubic-bezier(.15,.41,.69,.94);
//  animation-iteration-count: infinite;
//}
//@keyframes scroll {
//  0% { opacity: 0; }
//  10% { transform: translateY(0); opacity: 1; }
//  100% { transform: translateY(15px); opacity: 0;}
//}
</style>
